// extracted by mini-css-extract-plugin
module.exports = {"subnav":"Subnav_subnav__1RFSC","records":"Subnav_records__3uduc"};